import Vue from 'vue'

export default {
  getBondedLoan ({ commit }) {
    return Vue.axios.get('bonded-loan').then(({data}) => commit('SET_BONDED_LOAN', data))
  },
  saveBondedLoan ({ commit, dispatch, state }, bondedLoan) {
    return Vue.axios.put('bonded-loan', { bondedLoan })
      .then(({ data }) => {
        bondedLoan.id = data.id

        bondedLoan.promo_id = bondedLoan.promo_id && bondedLoan.promo_id !== ''
          ? bondedLoan.promo_id : null

        commit('SET_BONDED_LOAN', bondedLoan)

        if (bondedLoan.newPhoto) {
          dispatch('loadBondedLoanPhoto', { formData: bondedLoan.newPhoto })
        }

        if (bondedLoan.advantages) {
          bondedLoan.advantages.forEach((advantage) => {
            if (advantage.newPhoto) {
              dispatch(
                'loadBondedLoanAdvantagePreview',
                { formData: advantage.newPhoto, id: advantage.id }
              )
            }
          })
        }

        if (bondedLoan.letters) {
          bondedLoan.letters.forEach((letter) => {
            if (letter.newPreview) {
              dispatch('loadBondedLoanLetterPreview', { formData: letter.newPreview, id: letter.id })
            }
            if (letter.newFile) {
              dispatch('loadBondedLoanLetterFile', { formData: letter.newFile, id: letter.id })
            }
          })
        }
      })
  },
  // photo
  loadBondedLoanPhoto ({ commit }, { formData }) {
    return Vue.axios.post('bonded-loan/change-photo', formData)
  },
  // advantages
  addBondedLoanAdvantage ({ commit }, data) {
    commit('ADD_BONDED_LOAN_ADVANTAGE', data)
  },
  deleteBondedLoanAdvantage ({ commit }, id) {
    commit('DELETE_BONDED_LOAN_ADVANTAGE', id)
  },
  updateBondedLoanAdvantage ({ commit }, data) {
    commit('UPDATE_BONDED_LOAN_ADVANTAGE', data)
  },
  updateBondedLoanAdvantagesOrder ({ commit }, data) {
    commit('UPDATE_BONDED_LOAN_ADVANTAGES', data)
    return Vue.axios.put('bonded-loan/advantages/order', data)
  },
  loadBondedLoanAdvantagePreview ({ commit }, { formData, id }) {
    return Vue.axios.post(`bonded-loan/advantages/${id}/change-photo`, formData)
      .then(({ data }) => commit('CHANGE_BONDED_LOAN_ADVANTAGE_PREVIEW', data))
  },
  // letters
  addBondedLoanLetter ({ commit }, data) {
    commit('ADD_BONDED_LOAN_LETTER', data)
  },
  deleteBondedLoanLetter ({ commit }, id) {
    commit('DELETE_BONDED_LOAN_LETTER', id)
  },
  updateBondedLoanLetter ({ commit }, data) {
    commit('UPDATE_BONDED_LOAN_LETTER', data)
  },
  updateBondedLoanLettersOrder ({ commit }, data) {
    commit('UPDATE_BONDED_LOAN_LETTERS', data)
    return Vue.axios.put('bonded-loan/letters/order', data)
  },
  loadBondedLoanLetterPreview ({ commit }, { formData, id }) {
    return Vue.axios.post(`bonded-loan/letters/${id}/change-preview`, formData)
      .then(({ data }) => commit('CHANGE_BONDED_LOAN_LETTER_PREVIEW', data))
  },
  loadBondedLoanLetterFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`bonded-loan/letters/${id}/change-file`, formData)
  },
  changeBondedLoanLetterFile ({ commit }, { file, id, newFile }) {
    setTimeout(() => { commit('CHANGE_BONDED_LOAN_LETTER_FILE', {id, file, newFile}) }, 200)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/bondedLoan.js